import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    country: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const whatsappMessage = encodeURIComponent('Merhaba, izmirvizedanismanlik.net web siteniz üzerinden yazıyorum.');
  const whatsappUrl = `https://wa.me/905422671171?text=${whatsappMessage}`;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formElement = e.target as HTMLFormElement;
      const formDataToSend = new FormData(formElement);
      
      const response = await fetch('https://readdy.ai/api/form/d66c3skn78sauj0emb1g', {
        method: 'POST',
        body: new URLSearchParams(formDataToSend as any),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', country: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary/10 via-lightBlue to-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="font-heading font-bold text-4xl lg:text-5xl text-darkBlue mb-6">
              İletişim
            </h1>
            <p className="font-body text-lg text-gray-600 leading-relaxed">
              İzmir vize danışmanlık hizmetlerimiz hakkında bilgi almak için bizimle iletişime geçin. Ücretsiz ön değerlendirme için formu doldurun.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Contact Info */}
            <div className="space-y-8">
              <div>
                <h2 className="font-heading font-bold text-3xl text-darkBlue mb-6">
                  İzmir Vize Danışmanlık
                </h2>
                <p className="font-body text-gray-600 leading-relaxed mb-8">
                  Konak merkezli ofisimizden İzmir'in her noktasına profesyonel vize danışmanlık hizmeti sunuyoruz. Schengen vizesi, Amerika vizesi, İngiltere vizesi ve 50+ ülke için başvuru desteği.
                </p>
              </div>

              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center">
                    <i className="ri-map-pin-line text-secondary text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-heading font-bold text-lg text-darkBlue mb-2">Adres</h3>
                    <p className="font-body text-gray-600">
                      Fevzi Paşa Mah. 847/1 Sk. No:8 Kat:4 Daire:4/405<br />
                      Sağlık İş Hanı, Konak/İzmir
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center">
                    <i className="ri-phone-line text-secondary text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-heading font-bold text-lg text-darkBlue mb-2">Telefon</h3>
                    <a
                      href="tel:+905422671171"
                      className="font-body text-gray-600 hover:text-secondary transition-colors"
                    >
                      +90 542 267 11 71
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center">
                    <i className="ri-mail-line text-secondary text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-heading font-bold text-lg text-darkBlue mb-2">E-posta</h3>
                    <a
                      href="mailto:info@izmirvizedanismanlik.net"
                      className="font-body text-gray-600 hover:text-secondary transition-colors"
                    >
                      info@izmirvizedanismanlik.net
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center">
                    <i className="ri-time-line text-secondary text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-heading font-bold text-lg text-darkBlue mb-2">Çalışma Saatleri</h3>
                    <p className="font-body text-gray-600">
                      Pazartesi - Cuma: 09:00 - 18:00<br />
                      Cumartesi - Pazar: Kapalı
                    </p>
                  </div>
                </div>
              </div>

              {/* Map */}
              <div className="rounded-2xl overflow-hidden shadow-lg h-64">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3125.8!2d27.1287!3d38.4192!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzjCsDI1JzA5LjEiTiAyN8KwMDcnNDMuMyJF!5e0!3m2!1str!2str!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="İzmir Vize Danışmanlık Konum"
                ></iframe>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-lightBlue/30 rounded-2xl p-8 lg:p-10">
              <h3 className="font-heading font-bold text-2xl text-darkBlue mb-6">
                Ücretsiz Ön Değerlendirme Formu
              </h3>
              <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="name" className="block font-body font-semibold text-darkBlue mb-2">
                    Ad Soyad *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-secondary focus:outline-none font-body transition-colors"
                    placeholder="Adınız ve soyadınız"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block font-body font-semibold text-darkBlue mb-2">
                    E-posta *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-secondary focus:outline-none font-body transition-colors"
                    placeholder="ornek@email.com"
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="block font-body font-semibold text-darkBlue mb-2">
                    Telefon *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-secondary focus:outline-none font-body transition-colors"
                    placeholder="+90 5XX XXX XX XX"
                  />
                </div>

                <div>
                  <label htmlFor="country" className="block font-body font-semibold text-darkBlue mb-2">
                    Hangi Ülkeye Vize Başvurusu Yapmak İstiyorsunuz? *
                  </label>
                  <select
                    id="country"
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-secondary focus:outline-none font-body transition-colors"
                  >
                    <option value="">Ülke seçin</option>
                    <option value="Schengen - İspanya">Schengen - İspanya</option>
                    <option value="Schengen - Fransa">Schengen - Fransa</option>
                    <option value="Schengen - Almanya">Schengen - Almanya</option>
                    <option value="Schengen - İtalya">Schengen - İtalya</option>
                    <option value="Schengen - Yunanistan">Schengen - Yunanistan</option>
                    <option value="Schengen - Hollanda">Schengen - Hollanda</option>
                    <option value="Schengen - Diğer">Schengen - Diğer</option>
                    <option value="Amerika">Amerika</option>
                    <option value="İngiltere">İngiltere</option>
                    <option value="Kanada">Kanada</option>
                    <option value="Avustralya">Avustralya</option>
                    <option value="Diğer">Diğer</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="message" className="block font-body font-semibold text-darkBlue mb-2">
                    Mesajınız
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-secondary focus:outline-none font-body transition-colors resize-none"
                    placeholder="Vize başvurunuz hakkında detaylı bilgi verin (maksimum 500 karakter)"
                  ></textarea>
                  <p className="text-sm text-gray-500 mt-1 font-body">
                    {formData.message.length}/500 karakter
                  </p>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-secondary hover:bg-secondary/90 text-white px-8 py-4 rounded-full font-body font-bold transition-all shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  {isSubmitting ? 'Gönderiliyor...' : 'Formu Gönder'}
                </button>

                {submitStatus === 'success' && (
                  <div className="bg-green-50 border-2 border-green-500 rounded-lg p-4 flex items-start space-x-3">
                    <i className="ri-checkbox-circle-fill text-green-500 text-xl mt-0.5"></i>
                    <p className="font-body text-green-700">
                      Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız.
                    </p>
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="bg-red-50 border-2 border-red-500 rounded-lg p-4 flex items-start space-x-3">
                    <i className="ri-error-warning-fill text-red-500 text-xl mt-0.5"></i>
                    <p className="font-body text-red-700">
                      Bir hata oluştu. Lütfen tekrar deneyin veya bizi telefonla arayın.
                    </p>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Contact */}
      <section className="py-20 bg-gradient-to-r from-secondary to-orange-500">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="font-heading font-bold text-3xl lg:text-4xl text-white mb-4">
              Hızlı İletişim
            </h2>
            <p className="font-body text-lg text-white/90">
              Acil durumlar için doğrudan bizi arayabilir veya WhatsApp'tan yazabilirsiniz
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
            <a
              href="tel:+905422671171"
              className="bg-white hover:bg-gray-50 rounded-xl p-6 text-center transition-all hover:scale-105 shadow-lg"
            >
              <div className="w-16 h-16 bg-secondary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-secondary text-3xl"></i>
              </div>
              <h3 className="font-heading font-bold text-lg text-darkBlue mb-2">Telefon</h3>
              <p className="font-body text-secondary font-semibold">+90 542 267 11 71</p>
            </a>

            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white hover:bg-gray-50 rounded-xl p-6 text-center transition-all hover:scale-105 shadow-lg"
            >
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-whatsapp-line text-green-500 text-3xl"></i>
              </div>
              <h3 className="font-heading font-bold text-lg text-darkBlue mb-2">WhatsApp</h3>
              <p className="font-body text-green-600 font-semibold">Mesaj Gönder</p>
            </a>

            <a
              href="mailto:info@izmirvizedanismanlik.net"
              className="bg-white hover:bg-gray-50 rounded-xl p-6 text-center transition-all hover:scale-105 shadow-lg"
            >
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-line text-primary text-3xl"></i>
              </div>
              <h3 className="font-heading font-bold text-lg text-darkBlue mb-2">E-posta</h3>
              <p className="font-body text-primary font-semibold">E-posta Gönder</p>
            </a>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
